/* unplugin-vue-components disabled */import { render } from "./processCom.vue?vue&type=template&id=b265d472&scoped=true"
import script from "./processCom.vue?vue&type=script&lang=js"
export * from "./processCom.vue?vue&type=script&lang=js"

import "./processCom.vue?vue&type=style&index=0&id=b265d472&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.15_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b265d472"]])

export default __exports__